module.exports = __webpack_public_path__ + "img/第4章_3-3_元清觀謎題圖_2.jpg";